/*
  Инициализация каталога-флипбука поверх StPageFlip (assets/page-flip.browser.js).

  Книга поднимается лениво — когда секция попадает во вьюпорт: движок считает
  геометрию всех страниц сразу, и на длинных страницах это заметная работа.
*/
(function () {
  'use strict';

  var BASE_PAGE_WIDTH = 560; // опорная ширина страницы, реальную считает size: 'stretch'
  var PRELOAD_AHEAD = 4; // сколько полос держать загруженными впереди текущего разворота
  var PRELOAD_BEHIND = 2;
  var FLIP_TIME = 350; // должно совпадать с transition книги в section-catalog-flipbook.css
  var ZOOM_STEPS = [1, 1.5, 2, 2.5, 3];
  var ZOOM_MAX = ZOOM_STEPS[ZOOM_STEPS.length - 1];
  var TOOLS_TIMEOUT = 3500; // панель зума на телефоне прячется сама
  // Та же граница, что у @media в section-catalog-flipbook.css.
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function CatalogFlipbook(root) {
    this.root = root;
    this.book = root.querySelector('[data-catalog-flip-book]');
    this.source = root.querySelector('[data-catalog-flip-source]');
    this.skeleton = root.querySelector('[data-catalog-flip-skeleton]');
    this.counter = root.querySelector('[data-catalog-flip-counter]');
    // Стрелок по две пары: под книгой и по её бокам — ведут себя одинаково.
    this.prevBtns = root.querySelectorAll('[data-catalog-flip-prev]');
    this.nextBtns = root.querySelectorAll('[data-catalog-flip-next]');
    // Действия продублированы в мини-шапке и в нижней панели — работаем со всеми.
    this.fullscreenBtns = root.querySelectorAll('[data-catalog-flip-fullscreen]');

    this.viewport = root.querySelector('[data-catalog-flip-viewport]');
    this.zoomEl = root.querySelector('[data-catalog-flip-zoom]');
    this.panEl = root.querySelector('[data-catalog-flip-pan]');
    this.zoomInBtn = root.querySelector('[data-catalog-flip-zoom-in]');
    this.zoomOutBtn = root.querySelector('[data-catalog-flip-zoom-out]');
    this.zoomResetBtn = root.querySelector('[data-catalog-flip-zoom-reset]');
    this.toolsToggle = root.querySelector('[data-catalog-flip-tools-toggle]');
    this.thumbsToggle = root.querySelector('[data-catalog-flip-thumbs-toggle]');
    this.toolsTimer = null;
    this.pinching = false;

    this.shareBtns = root.querySelectorAll('[data-catalog-flip-share]');

    this.inner = root.querySelector('.catalog-flip__inner');
    this.stage = root.querySelector('.catalog-flip__stage');
    this.track = root.querySelector('[data-catalog-flip-track]');
    this.thumbs = root.querySelectorAll('[data-catalog-flip-thumb]');
    this.progress = root.querySelector('[data-catalog-flip-progress]');

    this.pages = this.source ? this.source.querySelectorAll('.catalog-flip__page') : [];
    this.zoom = 1;
    this.panX = 0;
    this.panY = 0;
    this.flip = null;
  }

  CatalogFlipbook.prototype.ratio = function () {
    var value = parseFloat(this.root.dataset.pageRatio);
    return value > 0 ? value : 0.675;
  };

  /* Файла может не быть в Files — тогда показываем понятную ошибку вместо битых картинок. */
  CatalogFlipbook.prototype.watchProbe = function () {
    var probe = this.root.querySelector('[data-catalog-flip-probe]');
    var self = this;
    if (!probe) return;

    var fail = function () {
      self.root.classList.add('has-error');
      if (self.flip) {
        self.flip.destroy();
        self.flip = null;
      }
    };

    if (probe.complete && probe.naturalWidth === 0) {
      fail();
      return;
    }
    probe.addEventListener('error', fail, { once: true });
  };

  /* Подставляет реальный src страницам вокруг текущего разворота. */
  CatalogFlipbook.prototype.preload = function (current) {
    var from = Math.max(0, current - PRELOAD_BEHIND);
    var to = Math.min(this.pages.length - 1, current + PRELOAD_AHEAD);

    for (var i = from; i <= to; i++) {
      var img = this.pages[i].querySelector('img[data-src]');
      if (!img) continue;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
  };

  CatalogFlipbook.prototype.init = function () {
    if (this.flip || !this.book || !this.pages.length) return;
    if (!window.St || !window.St.PageFlip) return;

    var ratio = this.ratio();
    var height = Math.round(BASE_PAGE_WIDTH / ratio);

    this.flip = new window.St.PageFlip(this.book, {
      width: BASE_PAGE_WIDTH,
      height: height,
      size: 'stretch',
      minWidth: 260,
      maxWidth: 900,
      minHeight: Math.round(260 / ratio),
      maxHeight: Math.round(900 / ratio),
      /* Обложку движку не отдаём: крайние полосы — невидимые заглушки из
         разметки, и книга всегда состоит из пар (см. комментарий в секции). */
      showCover: false,
      usePortrait: true,
      mobileScrollSupport: true,
      maxShadowOpacity: 0.5,
      flippingTime: FLIP_TIME,
      drawShadow: true,
      /* На телефоне тап по странице открывает панель зума, поэтому листать
         тапом движку нельзя — остаются свайп, уголки и нижние стрелки. */
      disableFlipByClick: MOBILE.matches
    });

    this.book.hidden = false;
    this.flip.loadFromHTML(this.pages);

    /* Свайп у движка считается только если уложился в 250 мс — на телефоне
       спокойный жест назад в это окно не попадает и превращается в
       «недотянутый» перегиб страницы. Даём свайпу больше времени. */
    if (this.flip.getUI) this.flip.getUI().swipeTimeout = 700;

    this.patchEngine();
    this.skipBlank();

    this.root.classList.add('is-ready');
    if (this.skeleton) this.skeleton.remove();

    this.bind();
    this.sync();
  };

  /*
    Две правки движка поверх экземпляра.

    1. Баг StPageFlip 2.0.7: flipNext() целится в угол с учётом rect.left, а
       flipPrev() — в x = 10 без него. В одностраничном режиме rect.left
       отрицательный, точка попадает в середину виртуального разворота, и при
       disableFlipByClick движок её отбрасывает — ни кнопка «назад», ни свайп
       назад не работают. Подменяем на симметричный flipNext().

    2. В одностраничном режиме невидимые заглушки по краям показывать нельзя:
       назад с обложки и вперёд с задника движку запрещаем. В развороте они и
       так стоят в паре с обложкой и задником.
  */
  CatalogFlipbook.prototype.patchEngine = function () {
    if (!this.flip.getFlipController || !this.flip.getRender) return;

    var app = this.flip;
    var controller = app.getFlipController();
    var render = app.getRender();

    controller.flipPrev = function (corner) {
      var rect = render.getRect();
      this.flip({ x: rect.left + 10, y: corner === 'top' ? 1 : rect.height - 2 });
    };

    var checkDirection = controller.checkDirection.bind(controller);
    controller.checkDirection = function (direction) {
      if (app.getOrientation() !== 'portrait') return checkDirection(direction);

      var current = app.getCurrentPageIndex();
      var total = app.getPageCount();
      // 0 — вперёд, 1 — назад (константы FlipDirection движка).
      return direction === 0 ? current < total - 2 : current >= 2;
    };
  };

  /* Одностраничный режим открылся на заглушке — переставляем на обложку без
     анимации. Событие flip при этом не приходит, поэтому sync() зовём сами. */
  CatalogFlipbook.prototype.skipBlank = function () {
    if (this.flip.getOrientation() !== 'portrait') return false;

    var current = this.flip.getCurrentPageIndex();
    var total = this.flip.getPageCount();
    var target = current === 0 ? 1 : current === total - 1 ? total - 2 : -1;
    if (target < 0) return false;

    this.flip.turnToPage(target);
    return true;
  };

  /*
    Сдвиг закрытой книги — CSS-класс, и ехать он должен одновременно с
    перелистыванием: иначе книга прыгает на четверть уже после анимации.
    Направление известно только при нажатии стрелки, поэтому классы
    переключаем здесь, а sync() в конце лишь подтверждает состояние.
  */
  CatalogFlipbook.prototype.anticipate = function (forward) {
    if (this.flip.getOrientation() === 'portrait') return;

    var current = this.flip.getCurrentPageIndex();
    var total = this.flip.getPageCount();

    if (forward) {
      this.root.classList.remove('is-cover-first');
      // Следующий разворот — [задник, пусто].
      if (current + 2 === total - 2) this.root.classList.add('is-cover-last');
    } else {
      this.root.classList.remove('is-cover-last');
      // Предыдущий разворот — [пусто, обложка].
      if (current === 2) this.root.classList.add('is-cover-first');
    }
  };

  /* Индексы движка: 0 — заглушка, 1 — обложка, …, N — задник, N+1 — заглушка.
     Так номер страницы для читателя совпадает с индексом движка. */
  CatalogFlipbook.prototype.realTotal = function () {
    return this.flip.getPageCount() - 2;
  };

  /* Начало разворота, в который попадает страница: пары (0,1), (2,3)… */
  CatalogFlipbook.prototype.spreadStart = function (index, portrait) {
    if (portrait) return Math.min(this.realTotal(), Math.max(1, index));
    return index - (index % 2);
  };

  /* Прыжок по клику в ленте: та же подготовка, что и у стрелок, только
     направление вычисляем из цели. Ленте передан номер страницы (1…N). */
  CatalogFlipbook.prototype.goTo = function (page) {
    var portrait = this.flip.getOrientation() === 'portrait';
    var current = this.flip.getCurrentPageIndex();
    var total = this.flip.getPageCount();
    var target = this.spreadStart(page, portrait);

    if (target === this.spreadStart(current, portrait)) return;

    if (!portrait) {
      this.root.classList.toggle('is-cover-first', target === 0);
      this.root.classList.toggle('is-cover-last', target === total - 2);
    }

    this.flip.flip(target);
  };

  CatalogFlipbook.prototype.turn = function (forward) {
    this.anticipate(forward);
    if (forward) {
      this.flip.flipNext();
    } else {
      this.flip.flipPrev();
    }
  };

  CatalogFlipbook.prototype.bind = function () {
    var self = this;

    this.flip.on('flip', function () {
      self.sync();
    });

    /* Тени объёма статичны и на лету только мешают: пока лист в движении (в том
       числе когда его тянут за угол), убираем их. Наведение на уголок
       (fold_corner) — ещё не переворот, тени остаются. */
    this.flip.on('changeState', function (event) {
      var moving = event.data === 'flipping' || event.data === 'user_fold';
      self.root.classList.toggle('is-flipping', moving);
    });

    this.prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.turn(false);
      });
    });

    this.nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.turn(true);
      });
    });

    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        self.turn(false);
      } else if (event.key === 'ArrowRight') {
        self.turn(true);
      } else {
        return;
      }
      event.preventDefault();
    });

    this.bindFullscreen();
    this.bindZoom();
    this.bindShare();
    this.bindMore();
    this.bindTools();
    this.bindPinch();
    this.bindThumbs();

    /* Смена ориентации меняет и разбивку ленты на развороты, и границы
       панорамы, а движок о таком не сообщает — слушаем resize сами. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!self.flip) return;
        if (self.zoom > 1) self.applyZoom();
        self.sync();
      }, 150);
    });
  };

  /*
    На своей странице каталог по умолчанию развёрнут: шапку и подвал сайта прячет
    класс catalog-bare на <body> (см. layout/theme.liquid). Кнопка тут не уводит в
    полный экран браузера, а снимает этот класс — страница становится обычной,
    с навигацией, а мини-шапка каталога уступает место нижней панели.
  */
  CatalogFlipbook.prototype.bindBare = function () {
    var self = this;

    var apply = function () {
      var bare = document.body.classList.contains('catalog-bare');
      var text = bare ? 'Exit full page' : 'Full page';

      self.fullscreenBtns.forEach(function (btn) {
        btn.hidden = false;
        btn.classList.toggle('is-bare', bare);
        btn.setAttribute('aria-label', text);

        var label = btn.querySelector('[data-catalog-flip-fullscreen-label]');
        if (label) label.textContent = text;
      });

      // Ширина сцены меняется вместе с режимом, а движок пересчитывает её по resize.
      window.dispatchEvent(new Event('resize'));
    };

    this.fullscreenBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.body.classList.toggle('catalog-bare');
        apply();
        if (document.body.classList.contains('catalog-bare')) return;
        self.root.scrollIntoView({ block: 'start' });
      });
    });

    apply();
  };

  CatalogFlipbook.prototype.bindFullscreen = function () {
    var self = this;
    if (!this.fullscreenBtns.length) return;

    if (this.root.dataset.catalogFlipBare === 'true') {
      this.bindBare();
      return;
    }

    var supported = !!(this.root.requestFullscreen || this.root.webkitRequestFullscreen);
    if (!supported) return;

    this.fullscreenBtns.forEach(function (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var active = document.fullscreenElement || document.webkitFullscreenElement;
        if (active) {
          (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        } else {
          (self.root.requestFullscreen || self.root.webkitRequestFullscreen).call(self.root);
        }
      });
    });

    document.addEventListener('fullscreenchange', function () {
      var active = document.fullscreenElement === self.root;
      var text = active ? 'Exit fullscreen' : 'Fullscreen';

      self.fullscreenBtns.forEach(function (btn) {
        btn.setAttribute('aria-label', text);
        var label = btn.querySelector('[data-catalog-flip-fullscreen-label]');
        if (label) label.textContent = text;
      });

      // StPageFlip пересчитывает размеры только по событию resize.
      window.dispatchEvent(new Event('resize'));
    });
  };

  /* --- зум и панорама --- */

  /* Панорама ограничена так, чтобы край увеличенной книги не отрывался от края
     окна просмотра: за границы уезжает ровно половина «лишнего» размера. */
  CatalogFlipbook.prototype.clampPan = function () {
    if (!this.viewport) return;

    var extraX = this.viewport.clientWidth * (this.zoom - 1) / 2;
    var extraY = this.viewport.clientHeight * (this.zoom - 1) / 2;

    this.panX = Math.max(-extraX, Math.min(extraX, this.panX));
    this.panY = Math.max(-extraY, Math.min(extraY, this.panY));
  };

  CatalogFlipbook.prototype.applyZoom = function () {
    if (!this.zoomEl) return;

    var zoom = this.zoom;
    this.clampPan();

    // translate идёт до scale, поэтому сдвиг остаётся в экранных пикселях.
    this.zoomEl.style.transform = zoom === 1
      ? ''
      : 'translate(' + Math.round(this.panX) + 'px, ' + Math.round(this.panY) + 'px) scale(' + zoom + ')';

    this.root.classList.toggle('is-zoomed', zoom > 1);
    if (this.panEl) this.panEl.hidden = zoom === 1;

    if (this.zoomResetBtn) {
      this.zoomResetBtn.textContent = Math.round(zoom * 100) + '%';
      this.zoomResetBtn.disabled = zoom === 1;
    }
    if (this.zoomOutBtn) this.zoomOutBtn.disabled = zoom <= ZOOM_STEPS[0];
    if (this.zoomInBtn) this.zoomInBtn.disabled = zoom >= ZOOM_MAX;
  };

  CatalogFlipbook.prototype.setZoom = function (zoom) {
    this.zoom = zoom;
    if (zoom === 1) {
      this.panX = 0;
      this.panY = 0;
    }
    this.applyZoom();
  };

  CatalogFlipbook.prototype.bindZoom = function () {
    if (!this.zoomEl) return;
    var self = this;

    /* После щипка зум может стоять между ступенями — идём к ближайшей
       ступени в нужную сторону, а не по индексу. */
    var step = function (delta) {
      var next = self.zoom;
      if (delta > 0) {
        for (var i = 0; i < ZOOM_STEPS.length; i++) {
          if (ZOOM_STEPS[i] > self.zoom + 0.01) { next = ZOOM_STEPS[i]; break; }
        }
      } else {
        for (var k = ZOOM_STEPS.length - 1; k >= 0; k--) {
          if (ZOOM_STEPS[k] < self.zoom - 0.01) { next = ZOOM_STEPS[k]; break; }
        }
      }
      self.setZoom(next);
      self.keepTools();
    };

    if (this.zoomInBtn) {
      this.zoomInBtn.addEventListener('click', function () {
        step(1);
      });
    }
    if (this.zoomOutBtn) {
      this.zoomOutBtn.addEventListener('click', function () {
        step(-1);
      });
    }
    if (this.zoomResetBtn) {
      this.zoomResetBtn.addEventListener('click', function () {
        self.setZoom(1);
        self.keepTools();
      });
    }

    if (this.panEl) {
      var dragging = false;
      var fromX = 0;
      var fromY = 0;

      var stop = function (event) {
        if (!dragging) return;
        dragging = false;
        if (event && self.panEl.releasePointerCapture && self.panEl.hasPointerCapture(event.pointerId)) {
          self.panEl.releasePointerCapture(event.pointerId);
        }
        self.panEl.classList.remove('is-grabbing');
        self.zoomEl.classList.remove('is-panning');
      };

      this.panEl.addEventListener('pointerdown', function (event) {
        dragging = true;
        fromX = event.clientX - self.panX;
        fromY = event.clientY - self.panY;
        if (self.panEl.setPointerCapture) self.panEl.setPointerCapture(event.pointerId);
        self.panEl.classList.add('is-grabbing');
        self.zoomEl.classList.add('is-panning');
        event.preventDefault();
      });

      this.panEl.addEventListener('pointermove', function (event) {
        if (!dragging || self.pinching) return;
        self.panX = event.clientX - fromX;
        self.panY = event.clientY - fromY;
        self.applyZoom();
      });

      this.panEl.addEventListener('pointerup', stop);
      this.panEl.addEventListener('pointercancel', stop);

      // Двойной клик по увеличенной странице возвращает масштаб к 100%.
      this.panEl.addEventListener('dblclick', function () {
        self.setZoom(1);
      });
    }

    this.applyZoom();
  };

  /* --- ссылка на каталог --- */

  CatalogFlipbook.prototype.bindShare = function () {
    var restore = null;

    /* Подписи у кнопки нет: об успехе говорит галочка вместо иконки. */
    var flash = function (btn, text) {
      var base = btn.dataset.shareLabel || btn.getAttribute('aria-label');
      btn.dataset.shareLabel = base;

      clearTimeout(restore);
      btn.classList.add('is-done');
      btn.setAttribute('aria-label', text);
      btn.setAttribute('title', text);

      restore = setTimeout(function () {
        btn.classList.remove('is-done');
        btn.setAttribute('aria-label', base);
        btn.setAttribute('title', base);
      }, 2200);
    };

    var copyFallback = function (btn, url) {
      var field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      var done = false;
      try {
        done = document.execCommand('copy');
      } catch (error) {
        done = false;
      }
      field.remove();
      flash(btn, done ? 'Link copied' : 'Copy failed');
    };

    this.shareBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = window.location.href.split('#')[0];

        // На телефоне уместнее системный лист, на десктопе — буфер обмена.
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            flash(btn, 'Link copied');
          }, function () {
            copyFallback(btn, url);
          });
          return;
        }

        copyFallback(btn, url);
      });
    });
  };

  /* --- Share + Download одной кнопкой (телефон) --- */

  CatalogFlipbook.prototype.bindMore = function () {
    var boxes = this.root.querySelectorAll('[data-catalog-flip-more]');
    if (!boxes.length) return;

    var closeAll = function (except) {
      boxes.forEach(function (box) {
        if (box === except) return;
        box.classList.remove('is-open');
        var toggle = box.querySelector('[data-catalog-flip-more-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    };

    boxes.forEach(function (box) {
      var toggle = box.querySelector('[data-catalog-flip-more-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = !box.classList.contains('is-open');
        closeAll(box);
        box.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });

      // Выбор пункта закрывает меню.
      box.querySelectorAll('.catalog-flip__more-menu .catalog-flip__btn').forEach(function (item) {
        item.addEventListener('click', function () {
          closeAll();
        });
      });
    });

    document.addEventListener('click', function () {
      closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  };

  /* --- панель зума (телефон) --- */

  CatalogFlipbook.prototype.setTools = function (open) {
    this.root.classList.toggle('is-tools-open', open);
    if (this.toolsToggle) this.toolsToggle.setAttribute('aria-expanded', String(open));
    clearTimeout(this.toolsTimer);
    if (open) this.keepTools();
  };

  /* Панель уходит сама; любое действие в ней заводит таймер заново. */
  CatalogFlipbook.prototype.keepTools = function () {
    if (!this.root.classList.contains('is-tools-open')) return;
    var self = this;
    clearTimeout(this.toolsTimer);
    this.toolsTimer = setTimeout(function () {
      self.setTools(false);
    }, TOOLS_TIMEOUT);
  };

  /* Тап — это pointerdown и pointerup почти в одной точке и быстро. Считается
     только центр страницы: уголки оставлены движку для перелистывания. */
  CatalogFlipbook.prototype.bindTools = function () {
    var self = this;

    if (this.toolsToggle) {
      this.toolsToggle.addEventListener('click', function () {
        self.setTools(!self.root.classList.contains('is-tools-open'));
      });
    }

    if (!this.viewport) return;
    var start = null;

    this.viewport.addEventListener('pointerdown', function (event) {
      start = { x: event.clientX, y: event.clientY, t: performance.now() };
    });

    this.viewport.addEventListener('pointerup', function (event) {
      if (!start || !MOBILE.matches || self.pinching) return;
      var moved = Math.hypot(event.clientX - start.x, event.clientY - start.y);
      var quick = performance.now() - start.t < 500;
      start = null;
      if (moved > 12 || !quick) return;

      var rect = self.viewport.getBoundingClientRect();
      var fx = (event.clientX - rect.left) / rect.width;
      var fy = (event.clientY - rect.top) / rect.height;
      if (fx < 0.2 || fx > 0.8 || fy < 0.25 || fy > 0.75) return;

      self.setTools(!self.root.classList.contains('is-tools-open'));
    });

    this.viewport.addEventListener('pointercancel', function () {
      start = null;
    });
  };

  /* --- щипок двумя пальцами (телефон) --- */

  /*
    Движок слушает touch-события и на второй палец отреагировал бы как на
    перегиб страницы. Пока идёт щипок, его touchmove/touchend глушим на окне
    в фазе захвата (его слушатели висят там же, но в фазе всплытия), а его
    текущий жест завершаем сами через userStop — в центре страницы это ничего
    не листает благодаря disableFlipByClick.
  */
  CatalogFlipbook.prototype.bindPinch = function () {
    if (!this.viewport || !this.zoomEl) return;
    var self = this;
    var pointers = {};
    var count = 0;
    var origin = null;

    var pointsOf = function () {
      var list = [];
      for (var id in pointers) list.push(pointers[id]);
      return list;
    };

    var geometry = function () {
      var p = pointsOf();
      return {
        dist: Math.hypot(p[1].x - p[0].x, p[1].y - p[0].y),
        mid: { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 }
      };
    };

    var settleEngine = function () {
      if (!self.flip || !self.flip.userStop || !self.flip.getRender) return;
      var rect = self.flip.getRender().getRect();
      self.flip.userStop({ x: rect.left + rect.pageWidth, y: rect.height / 2 }, false);
    };

    var begin = function () {
      var g = geometry();
      var rect = self.viewport.getBoundingClientRect();
      var center = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      origin = {
        dist: g.dist,
        zoom: self.zoom,
        // Точка книги под пальцами — она должна остаться под ними и после щипка.
        anchor: {
          x: (g.mid.x - center.x - self.panX) / self.zoom,
          y: (g.mid.y - center.y - self.panY) / self.zoom
        },
        center: center
      };
      self.pinching = true;
      self.zoomEl.classList.add('is-panning');
      settleEngine();
    };

    var update = function () {
      var g = geometry();
      var zoom = Math.min(ZOOM_MAX, Math.max(1, origin.zoom * g.dist / origin.dist));
      self.zoom = zoom;
      self.panX = g.mid.x - origin.center.x - origin.anchor.x * zoom;
      self.panY = g.mid.y - origin.center.y - origin.anchor.y * zoom;
      self.applyZoom();
    };

    var finish = function () {
      if (!self.pinching) return;
      self.pinching = false;
      origin = null;
      self.zoomEl.classList.remove('is-panning');
      // Почти единица — считаем, что вернули как было.
      if (self.zoom < 1.05) self.setZoom(1);
      settleEngine();
    };

    var forget = function (event) {
      if (!(event.pointerId in pointers)) return;
      delete pointers[event.pointerId];
      count--;
      if (count < 2) finish();
    };

    this.viewport.addEventListener('pointerdown', function (event) {
      if (!MOBILE.matches || event.pointerType !== 'touch') return;
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      count++;
      if (count === 2) begin();
    });

    this.viewport.addEventListener('pointermove', function (event) {
      if (!(event.pointerId in pointers)) return;
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      if (self.pinching && count >= 2) update();
    });

    this.viewport.addEventListener('pointerup', forget);
    this.viewport.addEventListener('pointercancel', forget);

    var mute = function (event) {
      if (!self.pinching) return;
      event.stopPropagation();
      if (event.cancelable) event.preventDefault();
    };
    window.addEventListener('touchmove', mute, { capture: true, passive: false });
    window.addEventListener('touchend', mute, { capture: true });
  };

  /* --- лента разворотов --- */

  CatalogFlipbook.prototype.bindThumbs = function () {
    var self = this;

    /* Телефон: лента в потоке между книгой и панелью, поэтому после
       показа/скрытия движку нужен resize — сцена меняет высоту. */
    if (this.thumbsToggle) {
      this.thumbsToggle.addEventListener('click', function () {
        var open = !self.root.classList.contains('is-thumbs-open');
        self.root.classList.toggle('is-thumbs-open', open);
        self.thumbsToggle.setAttribute('aria-expanded', String(open));
        window.dispatchEvent(new Event('resize'));
        if (open) self.sync();
      });
    }

    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // data-index в ленте с нуля, индекс движка (он же номер страницы) — с единицы.
        self.goTo((parseInt(thumb.dataset.index, 10) || 0) + 1);
      });
    });
  };

  /* Прокрутка ленты своими руками: scrollIntoView утащил бы за собой и
     страницу. На десктопе лента вертикальная, на телефоне горизонтальная —
     ось выбираем по тому, что реально переполнено. */
  CatalogFlipbook.prototype.scrollThumbsTo = function (start, end) {
    var track = this.track;
    if (!track) return;

    var from = this.thumbs[start];
    var to = this.thumbs[end] || from;
    if (!from) return;

    if (track.scrollHeight > track.clientHeight + 1) {
      var height = to.offsetTop + to.offsetHeight - from.offsetTop;
      var top = from.offsetTop - (track.clientHeight - height) / 2;
      top = Math.max(0, Math.min(track.scrollHeight - track.clientHeight, top));
      if (Math.abs(track.scrollTop - top) < 2) return;
      track.scrollTo({ top: top, behavior: 'smooth' });
      return;
    }

    if (track.scrollWidth <= track.clientWidth + 1) return;

    var width = to.offsetLeft + to.offsetWidth - from.offsetLeft;
    var left = from.offsetLeft - (track.clientWidth - width) / 2;
    left = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, left));

    if (Math.abs(track.scrollLeft - left) < 2) return;
    track.scrollTo({ left: left, behavior: 'smooth' });
  };

  /* first/last — номера первой и последней видимых страниц (1…N). */
  CatalogFlipbook.prototype.syncTimeline = function (first, last, realTotal, portrait) {
    if (!this.thumbs.length) return;

    this.thumbs.forEach(function (thumb, index) {
      var page = index + 1;
      var active = page >= first && page <= last;
      thumb.classList.toggle('is-active', active);
      if (active) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }

      // Обложка и задник стоят отдельно, остальное — парами (2,3), (4,5)…
      var pairEnd = !portrait && (page === 1 || page === realTotal || (page >= 3 && page % 2 === 1));
      thumb.classList.toggle('is-pair-end', pairEnd);
    });

    if (this.progress) {
      this.progress.style.setProperty('--catalog-flip-progress', (last / realTotal * 100) + '%');
    }

    this.layoutSidebar();
    this.scrollThumbsTo(first - 1, last - 1);
  };

  /* Десктоп: колонка превью стоит вплотную к левому краю разворота. Край
     считаем от сцены, а не от книги: у закрытой обложки книга сдвинута на
     четверть, но колонка должна стоять там, где ляжет открытый разворот. */
  CatalogFlipbook.prototype.layoutSidebar = function () {
    if (!this.inner || !this.stage || MOBILE.matches) return;

    var inner = this.inner.getBoundingClientRect();
    var stage = this.stage.getBoundingClientRect();
    this.inner.style.setProperty('--catalog-flip-stage-left', Math.round(stage.left - inner.left) + 'px');
  };

  /* Счётчик, доступность стрелок и центровка закрытой книги. */
  CatalogFlipbook.prototype.sync = function () {
    // Смена ориентации могла оставить книгу на заглушке.
    if (this.skipBlank()) return this.sync();

    var current = this.flip.getCurrentPageIndex();
    var total = this.flip.getPageCount();
    var realTotal = total - 2;
    var portrait = this.flip.getOrientation() === 'portrait';

    // Видимые страницы читателя: заглушки в счёт не идут.
    var first = Math.max(1, current);
    var last = portrait ? first : Math.min(realTotal, current + 1);

    if (this.counter) {
      var shown = first === last ? String(first) : first + '–' + last;
      this.counter.textContent = shown + ' / ' + realTotal;
    }

    var atStart = portrait ? current <= 1 : current === 0;
    var atEnd = portrait ? current >= realTotal : current + 2 >= total;

    this.prevBtns.forEach(function (btn) {
      btn.disabled = atStart;
    });
    this.nextBtns.forEach(function (btn) {
      btn.disabled = atEnd;
    });

    // Одностраничный режим: сгиба и торца у книги нет, CSS их убирает по классу.
    this.root.classList.toggle('is-portrait', portrait);
    this.root.classList.toggle('is-cover-first', !portrait && current === 0);
    this.root.classList.toggle('is-cover-last', !portrait && current === total - 2);

    this.syncTimeline(first, last, realTotal, portrait);
    this.syncSlide();
    this.preload(current);
  };

  /*
    Движок считает длительность переворота от пути уголка: flippingTime, если
    путь ≥ 1000px, иначе пропорционально короче (см. getAnimationDuration).
    Путь ≈ 2·ширина страницы − высота/10. Сдвиг книги под обложку должен
    длиться ровно столько же — иначе обложка уже легла, а книга ещё едет.
  */
  CatalogFlipbook.prototype.syncSlide = function () {
    if (!this.flip.getRender) return;

    var rect = this.flip.getRender().getRect();
    if (!rect) return;

    var distance = 2 * rect.pageWidth - rect.height / 10;
    var ms = Math.round(FLIP_TIME * Math.min(1, distance / 1000));
    // Читают и сдвиг книги, и «утапливание» соседки под обложкой (CSS).
    this.root.style.setProperty('--catalog-flip-turn', ms + 'ms');
  };

  function setup(root) {
    if (root.dataset.catalogFlipReady === 'true') return;
    root.dataset.catalogFlipReady = 'true';

    var instance = new CatalogFlipbook(root);
    instance.watchProbe();

    /* page-flip.browser.js подключён с defer и может приехать как до, так и
       после window.load — поэтому ждём сам глобал, а не событие загрузки. */
    var start = function () {
      var waited = 0;
      var tick = function () {
        if (window.St && window.St.PageFlip) {
          instance.init();
          return;
        }
        waited += 50;
        if (waited <= 10000) setTimeout(tick, 50);
      };
      tick();
    };

    /* Если секция уже на экране — поднимаем книгу сразу. Ждать колбэка
       IntersectionObserver здесь нельзя: в фоновой вкладке он не приходит,
       и каталог остался бы неинициализированным до возврата на вкладку. */
    var visible = function () {
      var rect = root.getBoundingClientRect();
      return rect.top < window.innerHeight + 200 && rect.bottom > -200;
    };

    if (visible() || !('IntersectionObserver' in window)) {
      start();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        start();
      });
    }, { rootMargin: '200px' });

    observer.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-catalog-flip]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Перерисовка секции в редакторе тем.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
